import { ContractCP } from '../models/contract-model';

/**
 * contract start with 'c' or having negative amount due will be consider as credit contract
 * @param contract
 * @returns boolean
 */
export const isCreditContract = (contract: ContractCP): boolean => Number(contract.AmountDue) !== 0 && (contract.contractId.startsWith('c') || Number(contract.AmountDue) < 0);
